// @flow

import React from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";
import type { Employee } from "@modules/employee/reducer/employee/types";
import { SearchEmployeeForm } from "@modules/shared/components";
import type { AlertBespokeRecipient } from "@modules/service/reducer/alerts/types";
import { GSGrid, Icons } from "@components";

type OwnProps = $Exact<{
  clientId: number,
  employeeResults: Array<Employee>,
  searchEmployees: Object => void,
  showModal: boolean,
  editable: boolean,
  selectedEmployee: Employee | Object,
  data: Object | null,
  onCancel: () => void,
  selectEmployee: (item: Employee) => void,
  onSubmit: (bespoke: AlertBespokeRecipient) => void,
  handleSubmit: (values: Object, valid: true) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

type OwnState = $Exact<{
  selected: Employee,
}>;
export class SearchEmployeeBySurname extends React.Component<Props, OwnState> {
  state = {
    selected: {},
  };
  selectEmployee = (item: Employee) => () => {
    this.props.selectEmployee(item);
    this.setState({ selected: item });
  };
  get columns() {
    return [
      {
        name: this.props.t("EMPLOYEE_REF"),
        key: "employeeRefPrimary",
        align: "left",
      },
      {
        name: this.props.t("FIRST_NAME"),
        key: "firstName",
        align: "left",
      },
      {
        name: this.props.t("SURNAME"),
        key: "lastName",
        align: "left",
      },
      {
        name: this.props.t("EMAIL"),
        key: "email",
        align: "left",
        renderCell: ({ row }: *) => (row.contactDetails || {}).workEmail || row.workEmail,
      },
      {
        name: this.props.t("EDIT"),
        key: "edit",
        renderCell: ({ row }: *) =>
          this.props.editable ? (
            <div className="d-flex align-items-center pointer" onClick={this.onSubmit(row)}>
              <span>{this.props.t("SELECT")}</span>
              <Icons.ArrowRightIcon className="ml-1" />
            </div>
          ) : null,
      },
    ];
  }
  search = (formData: { surname: string }) => {
    this.props.searchEmployees({ clientId: this.props.clientId, page: 1, filters: formData });
  };

  onSubmit = (item: Employee) => () => {
    this.selectEmployee(item);
    this.props.handleSubmit(item || {}, true);
  };
  componentDidUpdate() {
    if (this.props.selectedEmployee.id && !this.state.selected.id) {
      this.setState({ selected: this.props.selectedEmployee });
    }
  }

  render() {
    if (!this.props.editable) {
      return (
        <GSGrid
          rows={[
            (this.state.selected || {}).id ? (this.state || {}).selected : this.props.data || {},
          ]}
          disabled={true}
          columns={this.columns}
        />
      );
    }
    return (
      <div className="d-flex flex-column justify-content-center flex-grow-1">
        <div className={"p-x-3 justify-content-center"}>
          <SearchEmployeeForm labelMsgId="SEARCH_EMPLOYEE_BY_SURNAME" onSubmit={this.search} />
        </div>
        <div className={"flex-grow-1"}>
          {this.props.employeeResults ? (
            <GSGrid rows={this.props.employeeResults} columns={this.columns} />
          ) : null}
        </div>
      </div>
    );
  }
}

export default compose(localize())(SearchEmployeeBySurname);
